import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { MenuOption } from 'legacyComponents/layout/menuOption';
import { modalStore } from 'apps/modals/app';
import { Modal } from 'apps/modals/views/modal';
import { clientStore } from 'apps/client/app';
import { PostForm } from 'apps/aggregator/postForm';

import { MenuModalTitle } from 'apps/modals/menu/menu.styles';
import { importServices } from 'libs/forms/validators';

import { analytics } from 'core/analytics';

import { conf } from './config.yaml';

@withNamespaces()
@observer
export class Menu extends Modal {
  clickAction = a => {
    const { routerStore } = clientStore;
    const { route } = routerStore;

    modalStore.ClearComponent();
    if (a === 'leaveFeedback') {
      routerStore.navigate('initiative.forum', {
        initiative: '+wikifactory',
      });
    }
    if (a === 'createInitiative') {
      analytics.sendEvent('clicked-create-organization', {}, { ga: true });
    }
    if (a === 'submitLink') {
      analytics.sendEvent('clicked-post', {}, { ga: true });
    }
    if (a === 'tellStory') {
      analytics.sendEvent('clicked-new-story', {}, { ga: true });
    }
    if (a === 'shareProject') {
      analytics.sendEvent('clicked-start-project', {}, { ga: true });
    }
    if (a === 'shareFile') {
      analytics.sendEvent('start-share-file');
      analytics.sendEvent('start-share-file-menu');
      routerStore.navigate('workspace.share-file', {
        spacePath:
          route.params.spacePath ||
          route.params.profile ||
          route.params.initiative,
      });
    }
    if (a === 'makePart') {
      analytics.sendEvent(
        'make-part-click-menu',
        {},
        {
          ga: true,
        },
      );
    }
  };

  render() {
    const { isStaff } = clientStore;

    const actions = Object.entries(conf.actions);
    return (
      <>
        <MenuModalTitle size='large'>
          <Trans>What would you like to do?</Trans>
        </MenuModalTitle>
        {actions.map(([name, action]) => {
          if (name === 'tellStory' && !isStaff) {
            return null;
          }

          let { description } = action;
          let servicesString = '';
          importServices.forEach((service, i) => {
            servicesString += service;
            if (i < importServices.length - 1) {
              if (i === importServices.length - 2) {
                servicesString += ' or ';
              } else {
                servicesString += ', ';
              }
            }
          });
          if (name === 'importProject') {
            description = description.replace(
              '{services}',
              servicesString || 'the supported services',
            );
          }
          return (
            <MenuOption
              linkName={action.link}
              title={action.title}
              icon={action.icon}
              id={action.id}
              disabled
              dataFor={action.dataFor}
              dataTip={action.dataTip}
              shortcut={action.shortcut}
              description={description}
              onclick={
                action.onClick === 'setModelToPostForm'
                  ? () => modalStore.SetModalComponent(PostForm)
                  : () => this.clickAction(name)
              }
              key={action.title}
            />
          );
        })}
      </>
    );
  }
}

Menu.propTypes = {
  fadeIn: PropTypes.func,
  clickCancel: PropTypes.func,
};
